if (!customElements.get('ggx-warehouse-filters')) {
  customElements.define('ggx-warehouse-filters', class extends HTMLElement {
    connectedCallback() {
      if (this.ready || typeof window.HTMLDialogElement?.prototype.showModal !== 'function') return;
      this.fallback = this.querySelector('.ggx-refine-fallback');
      this.panel = this.querySelector('.ggx-refine-panel');
      this.trigger = this.querySelector('[data-ggx-open]');
      this.form = this.querySelector('.ggx-catalog-form');
      if (!this.fallback || !this.panel || !this.trigger || !this.form) return;
      this.ready = true;
      this.syncCoffeeGroups();
      this.setAttribute('data-enhanced', '');
      this.events = new AbortController();
      this.initSeries();
      this.applyButton = this.querySelector('[data-ggx-apply]');
      this.status = this.querySelector('.ggx-filter-status');
      this.facetDefaults = [...this.form.querySelectorAll('input[type="checkbox"]')].map((input) => ({ input, disabled: input.disabled, label: input.closest('label')?.querySelector('span'), text: input.closest('label')?.querySelector('span')?.textContent }));
      this.dialog = document.createElement('dialog');
      this.dialog.className = 'ggx-filter-dialog';
      this.dialog.id = this.trigger.getAttribute('aria-controls');
      this.dialog.setAttribute('aria-labelledby', this.panel.querySelector('h2').id);
      this.dialog.append(this.panel);
      this.append(this.dialog);
      this.fallback.hidden = true;
      this.trigger.hidden = false;
      const close = this.panel.querySelector('[data-ggx-close]');
      close.hidden = false;
      close.autofocus = true;
      const clear = this.panel.querySelector('[data-ggx-clear]');
      clear.hidden = false;
      this.panel.querySelector('.ggx-clear-fallback').hidden = true;
      const options = { signal: this.events.signal };
      this.formatNav = this.querySelector('.ggx-format-nav');
      if (this.formatNav) {
        this.formatNav.addEventListener('toggle', () => this.positionFormats(), options);
        window.addEventListener('resize', () => this.positionFormats(), options);
        document.addEventListener('scroll', () => this.positionFormats(), { ...options, capture: true, passive: true });
        this.positionFormats();
        document.addEventListener('click', (event) => {
          if (!this.formatNav.contains(event.target)) this.formatNav.open = false;
        }, options);
        this.formatNav.addEventListener('keydown', (event) => {
          if (event.key !== 'Escape' || !this.formatNav.open) return;
          event.preventDefault();
          this.formatNav.open = false;
          this.formatNav.querySelector('summary').focus();
        }, options);
      }

      this.trigger.addEventListener('click', () => this.open(), options);
      close.addEventListener('click', () => this.close(), options);
      this.dialog.addEventListener('cancel', (event) => { event.preventDefault(); this.close(); }, options);
      this.dialog.addEventListener('close', () => { if (!this.dialog.open) this.restore(); }, options);
      this.dialog.addEventListener('click', (event) => {
        if (event.target !== this.dialog) return;
        const bounds = this.dialog.getBoundingClientRect();
        if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) this.close();
      }, options);
      this.dialog.addEventListener('keydown', (event) => {
        if (event.key !== 'Tab') return;
        const focusable = [...this.dialog.querySelectorAll('a[href],button:not(:disabled),input:not(:disabled):not([type="hidden"]),select:not(:disabled),textarea:not(:disabled),summary,[tabindex]:not([tabindex="-1"])')].filter((element) => element.getClientRects().length && getComputedStyle(element).visibility !== 'hidden');
        const first = focusable[0], last = focusable[focusable.length - 1];
        if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last?.focus(); }
        else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first?.focus(); }
      }, options);
      this.form.addEventListener('input', () => this.scheduleCount(), options);
      this.form.addEventListener('change', () => this.scheduleCount(), options);
      this.form.addEventListener('submit', (event) => {
        if (this.form.querySelector('[data-coffee-tag]')) { event.preventDefault(); window.location.assign(this.filterUrl().href); }
        clearTimeout(this.timer);
        this.request?.abort();
      }, options);
      clear.addEventListener('click', () => {
        for (const input of this.form.querySelectorAll('input[name^="filter."]')) {
          if (input.type === 'checkbox') input.checked = false;
          else input.value = '';
        }
        for (const select of this.form.querySelectorAll('[data-coffee-tag]')) select.value = '';
        this.syncCoffeeGroups();
        this.scheduleCount();
      }, options);
      const current = new URL(window.location.href);
      const preview = current.searchParams.get('preview_theme_id');
      if (preview) {
        for (const form of this.querySelectorAll('form')) {
          if (form.querySelector('[name="preview_theme_id"]')) continue;
          const input = document.createElement('input');
          input.type = 'hidden';
          input.name = 'preview_theme_id';
          input.value = preview;
          form.append(input);
        }
        for (const link of this.querySelectorAll('a[href]')) {
          const url = new URL(link.href, window.location.href);
          if (url.origin !== current.origin) continue;
          url.searchParams.set('preview_theme_id', preview);
          link.href = url.href;
        }
      }
      window.addEventListener('pagehide', () => this.dialog.open && this.dialog.close(), options);
      window.addEventListener('pageshow', (event) => {
        if (!event.persisted) return;
        if (this.formatNav) this.formatNav.open = false;
        if (this.dialog.open) this.dialog.close();
        this.resetForm();
        this.setCount(this.dataset.count);
      }, options);
    }
    initSeries() {
      this.seriesNav = this.querySelector('.ggx-series-quick');
      if (!this.seriesNav) return;
      this.seriesCards = [...this.querySelectorAll('[data-ggx-card-series]')];
      this.seriesField = this.form.querySelector('input[name="gg_series"]') || document.createElement('input');
      this.seriesField.type = 'hidden';
      this.seriesField.name = 'gg_series';
      this.form.append(this.seriesField);
      const options = { signal: this.events.signal };
      this.seriesNav.addEventListener('click', event => {
        const button = event.target.closest('[data-ggx-series]');
        if (button) this.selectSeries(button.dataset.ggxSeries, true);
      }, options);
      this.querySelector('[data-ggx-series-reset]')?.addEventListener('click', () => {
        const url = new URL(this.dataset.collectionUrl, location.href);
        url.searchParams.set('view', 'gg-warehouse');
        const preview = new URL(location.href).searchParams.get('preview_theme_id');
        if (preview) url.searchParams.set('preview_theme_id', preview);
        location.assign(url.href);
      }, options);
      window.addEventListener('popstate', () => this.selectSeries(new URL(location.href).searchParams.get('gg_series')), options);
      window.addEventListener('pageshow', () => this.selectSeries(new URL(location.href).searchParams.get('gg_series')), options);
      if (new URL(location.href).searchParams.get('gg_roast') === 'medium-dark') {
        const roast = this.form.querySelector('[data-coffee-tag="roast"]');
        if (roast) { roast.value = 'gg-finder-roast-medium-dark'; roast.defaultValue = roast.value; }
      }
      this.selectSeries(new URL(location.href).searchParams.get('gg_series'));
      this.seriesNav.hidden = false;
    }
    selectSeries(series, push = false) {
      const buttons = [...this.seriesNav.querySelectorAll('[data-ggx-series]')];
      this.series = buttons.some(button => button.dataset.ggxSeries === series) ? series : 'all';
      this.seriesField.value = this.series;
      let count = 0;
      this.seriesCards.forEach(card => { card.hidden = (this.series !== 'all' && card.dataset.ggxCardSeries !== this.series) || (new URL(location.href).searchParams.get('gg_roast') === 'medium-dark' && card.dataset.ggxMediumDark !== 'true'); if (!card.hidden) count++; });
      buttons.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.ggxSeries === this.series)));
      const label = buttons.find(button => button.dataset.ggxSeries === this.series).textContent;
      this.querySelector('[data-result-count]').textContent = `${count} coffees`;
      this.querySelector('.ggx-series-status').textContent = `${label}: ${count} coffees`;
      this.querySelector('.ggx-series-empty').hidden = count > 0;
      const originalEmpty = this.querySelector('.ggx-empty:not(.ggx-series-empty)');
      if (originalEmpty) originalEmpty.hidden = true;
      if (push) {
        const url = new URL(location.href);
        if (this.series === 'all') url.searchParams.delete('gg_series'); else url.searchParams.set('gg_series', this.series);
        history.pushState({}, '', url);
      }
      // Preserve the selected series when clearing other filters.
      this.querySelectorAll('a.ggx-active-chip,.ggx-clear-fallback').forEach(link => {
        const url = new URL(link.href, location.href);
        if (this.series === 'all') url.searchParams.delete('gg_series'); else url.searchParams.set('gg_series', this.series);
        link.href = url.href;
      });
    }
    positionFormats() {
      if (!this.formatNav?.open) return;
      const bounds = this.formatNav.getBoundingClientRect();
      const header = document.querySelector('header-component')?.getBoundingClientRect();
      const viewportBottom = window.visualViewport ? window.visualViewport.offsetTop + window.visualViewport.height : window.innerHeight;
      const topLimit = header ? Math.max(0, Math.min(header.bottom, viewportBottom)) : 0;
      const below = Math.max(0, viewportBottom - bounds.bottom - 16);
      const above = Math.max(0, bounds.top - topLimit - 16);
      const opensAbove = below < 176 && above > below;
      this.formatNav.dataset.position = opensAbove ? 'above' : 'below';
      this.formatNav.style.setProperty('--ggx-format-space', `${Math.max(44, Math.floor(opensAbove ? above : below))}px`);
    }
    resetForm() {
      this.form.reset();
      if (this.seriesField) this.seriesField.value = this.series;
      this.syncCoffeeGroups();
      for (const facet of this.facetDefaults) {
        facet.input.disabled = facet.disabled;
        if (facet.label) facet.label.textContent = facet.text;
      }
    }
    open() {
      if (this.dialog.open) return;
      if (this.formatNav) this.formatNav.open = false;
      this.scheduleCount();
      this.panel.querySelector('.ggx-refine-body').scrollTop = 0;
      if (this.savedOverflow === undefined) {
        this.savedOverflow = document.documentElement.style.overflow;
        this.savedGutter = document.documentElement.style.scrollbarGutter;
        this.savedScrollLock = document.documentElement.hasAttribute('scroll-lock');
        this.scrollContainer = document.querySelector('.page-wrapper');
        this.savedWrapperGutter = this.scrollContainer?.style.scrollbarGutter;
        this.savedScroll = [...new Set([document.scrollingElement, this.scrollContainer])].filter(Boolean).map((element) => ({ element, top: element.scrollTop, left: element.scrollLeft }));
      }
      document.documentElement.style.scrollbarGutter = 'stable';
      document.documentElement.style.overflow = 'hidden';
      if (this.scrollContainer) this.scrollContainer.style.scrollbarGutter = 'stable';
      document.documentElement.setAttribute('scroll-lock', '');
      this.dialog.showModal();
      this.trigger.setAttribute('aria-expanded', 'true');
    }
    close() {
      if (!this.dialog.open || this.dialog.classList.contains('is-closing')) return;
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) { this.dialog.close(); return; }
      this.dialog.classList.add('is-closing');
      this.closeTimer = setTimeout(() => { if (this.dialog.open) this.dialog.close(); }, 220);
    }
    restore() {
      clearTimeout(this.closeTimer);
      this.dialog.classList.remove('is-closing');
      clearTimeout(this.timer);
      this.request?.abort();
      if (this.savedOverflow !== undefined) {
        document.documentElement.style.overflow = this.savedOverflow;
        document.documentElement.style.scrollbarGutter = this.savedGutter;
        if (this.scrollContainer) this.scrollContainer.style.scrollbarGutter = this.savedWrapperGutter;
        if (!this.savedScrollLock) document.documentElement.removeAttribute('scroll-lock');
        for (const scroll of this.savedScroll) scroll.element.scrollTo?.({ top: scroll.top, left: scroll.left, behavior: 'instant' });
        this.savedOverflow = undefined;
      }
      this.applyButton.removeAttribute('aria-busy');
      this.trigger.setAttribute('aria-expanded', 'false');
      if (this.isConnected) this.trigger.focus({ preventScroll: true });
    }
    setCount(count) {
      this.applyButton.textContent = this.dataset.countsExact === 'false' ? this.dataset.applyLabel : this.dataset.resultsTemplate.replace('__COUNT__', count);
      this.status.textContent = this.applyButton.textContent;
      this.applyButton.removeAttribute('aria-busy');
    }
    syncCoffeeGroups() {
      const style = this.form.querySelector('[data-coffee-tag="style"]');
      if (!style) return;
      const flavored = style.value === 'gg-finder-style-flavored';
      for (const group of this.form.querySelectorAll('[data-coffee-group]')) {
        const show = group.dataset.coffeeGroup === 'flavor' ? flavored : !flavored;
        group.hidden = !show;
        const select = group.querySelector('select');
        if (select) { select.disabled = !show; if (!show) select.value = ''; }
      }
    }
    filterUrl() {
      const url = new URL(this.form.action, window.location.href);
      const controls = [...this.form.querySelectorAll('[data-coffee-tag]')];
      if (controls.length) {
        const tags = controls.filter(input => !input.disabled && input.value && !(this.seriesNav && input.value === 'gg-finder-roast-medium-dark')).map(input => encodeURIComponent(input.value));
        url.pathname = this.dataset.collectionUrl + (tags.length ? '/' + tags.join('+') : '');
      }
      url.search = new URLSearchParams(new FormData(this.form)).toString();
      if (this.seriesNav && controls.some(input => !input.disabled && input.value === 'gg-finder-roast-medium-dark')) url.searchParams.set('gg_roast', 'medium-dark');
      else url.searchParams.delete('gg_roast');
      return url;
    }
    scheduleCount() {
      this.syncCoffeeGroups();
      clearTimeout(this.timer);
      this.request?.abort();
      this.applyButton.textContent = this.dataset.applyLabel;
      this.status.textContent = this.dataset.checkingLabel;
      this.applyButton.setAttribute('aria-busy', 'true');
      this.timer = setTimeout(() => this.updateCount(), 250);
    }
    async updateCount() {
      if (!this.form.checkValidity()) {
        this.applyButton.removeAttribute('aria-busy');
        this.status.textContent = '';
        return;
      }
      const request = new AbortController();
      this.request = request;
      const url = this.filterUrl();
      url.hash = '';
      url.searchParams.set('section_id', this.dataset.sectionId);
      try {
        const response = await fetch(url, { signal: request.signal });
        if (!response.ok) throw new Error('Filter count unavailable');
        const document = new DOMParser().parseFromString(await response.text(), 'text/html');
        let count = document.querySelector('[data-result-count]')?.dataset.resultCount;
        if (this.seriesNav) count = String([...document.querySelectorAll('[data-ggx-card-series]')].filter(card => (this.series === 'all' || card.dataset.ggxCardSeries === this.series) && (url.searchParams.get('gg_roast') !== 'medium-dark' || card.dataset.ggxMediumDark === 'true')).length);
        const countsExact = document.querySelector('ggx-warehouse-filters')?.dataset.countsExact !== 'false';
        if (countsExact && (!count || !/^\d+$/.test(count))) throw new Error('Filter count unavailable');
        if (!request.signal.aborted && this.dialog.open) {
          const freshInputs = [...document.querySelectorAll('.ggx-catalog-form input[type="checkbox"]')];
          for (const input of this.form.querySelectorAll('input[type="checkbox"]')) {
            const fresh = freshInputs.find((candidate) => candidate.name === input.name && candidate.value === input.value);
            if (!fresh) continue;
            input.disabled = fresh.disabled && !input.checked;
            const label = input.closest('label')?.querySelector('span');
            const freshLabel = fresh.closest('label')?.querySelector('span');
            if (label && freshLabel) label.textContent = freshLabel.textContent;
          }
          this.setCount(count);
        }
      } catch (error) {
        if (error.name !== 'AbortError') {
          this.applyButton.removeAttribute('aria-busy');
          this.status.textContent = '';
        }
      }
    }
    disconnectedCallback() {
      if (!this.ready) return;
      this.events.abort();
      if (this.dialog.open) this.dialog.close();
      this.restore();
      this.fallback.append(this.panel);
      this.dialog.remove();
      this.fallback.hidden = false;
      this.trigger.hidden = true;
      this.removeAttribute('data-enhanced');
      this.ready = false;
    }
  });
}


